import { registerPlugin } from "./utils/registerPlugin"

type IInfoPlugin = {
  getSerialNumber: () => Promise<{ value: string }>
  getMerchantId: () => Promise<{ value: string }>
  getDeviceSecret: () => Promise<{ value: string }>
  getAppVersion: () => Promise<{ value: string }>
  getPrintingSupported: () => Promise<{ value: boolean }>
}

export const IInfo = registerPlugin<IInfoPlugin>(
  "IInfoPlugin",
  {
    getSerialNumber: () => {
      let _serial = localStorage.getItem(
        "deviceSerialNumber"
      )
      if (_serial === null) {
        _serial = `app-web-${new Date().getTime()}`
        localStorage.setItem("deviceSerialNumber", _serial)
      }
      return Promise.resolve({ value: _serial })
    },
    getMerchantId: () =>
      Promise.resolve({ value: "123456789" }),
    getDeviceSecret: () =>
      Promise.resolve({ value: "secret" }),
    getAppVersion: () => Promise.resolve({ value: "web" }),
    getPrintingSupported: () =>
      Promise.resolve({ value: false }),
  }
)
